import { render, staticRenderFns } from "./ProdWhInventory.vue?vue&type=template&id=a6f5ce2c&scoped=true"
import script from "./ProdWhInventory.vue?vue&type=script&lang=js"
export * from "./ProdWhInventory.vue?vue&type=script&lang=js"
import style0 from "./ProdWhInventory.vue?vue&type=style&index=0&id=a6f5ce2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f5ce2c",
  null
  
)

export default component.exports